import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Icon, NewButton } from '../../../../../components';
import { AssetFooterSource } from '../../atoms';

const AssetActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const ActionsContainer = styled.div`
  display: flex;
  column-gap: 8px;
`;

const SourcesContainer = styled.div`
  display: flex;
  column-gap: 4px;
  align-items: center;
`;

const AssetActions = ({ onCopyTable = null, onDownload, sources = [] }) => {
  const [iconName, setIconName] = useState('copy');

  const handleCopyTable = () => {
    onCopyTable();
    setIconName('check');
    setTimeout(() => {
      setIconName('copy');
    }, 5000);
  };

  return (
    <AssetActionsContainer>
      <SourcesContainer>
        {sources.map((source, index) => (
          <AssetFooterSource
            key={source.id}
            source={source}
            showPlus={index !== sources.length - 1}
          />
        ))}
      </SourcesContainer>
      <ActionsContainer>
        {onCopyTable && (
          <NewButton onClick={handleCopyTable}>
            <Icon name={iconName} displaySize={20} />
          </NewButton>
        )}
        <NewButton onClick={onDownload}>
          <Icon name='download' displaySize={20} />
        </NewButton>
      </ActionsContainer>
    </AssetActionsContainer>
  );
};

AssetActions.propTypes = {
  onCopyTable: PropTypes.func,
  onDownload: PropTypes.func.isRequired,
  sources: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      integration: PropTypes.shape({
        displayName: PropTypes.string.isRequired,
        picture: PropTypes.string
      })
    })
  )
};

export { AssetActions };
